/**
 * Brand-faithful IdP marks for SSO (inline SVG — no external CDN / CSP-safe).
 */
import React from 'react';

export function ProviderMark({ id, className = 'w-5 h-5' }) {
  const key = String(id || '').toLowerCase();
  switch (key) {
    case 'google':
      return (
        <svg className={className} viewBox="0 0 24 24" aria-hidden>
          <path
            fill="#4285F4"
            d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
          />
          <path
            fill="#34A853"
            d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
          />
          <path
            fill="#FBBC05"
            d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
          />
          <path
            fill="#EA4335"
            d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
          />
        </svg>
      );
    case 'github':
      return (
        <svg className={className} viewBox="0 0 24 24" aria-hidden fill="#181717">
          <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61-.546-1.387-1.333-1.757-1.333-1.757-1.09-.745.083-.73.083-.73 1.205.085 1.84 1.236 1.84 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.418-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.468-2.381 1.235-3.221-.123-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.52 11.52 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.119 3.176.77.84 1.233 1.911 1.233 3.221 0 4.61-2.807 5.625-5.479 5.921.43.372.823 1.102.823 2.222 0 1.606-.015 2.896-.015 3.286 0 .322.216.694.825.576C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12" />
        </svg>
      );
    case 'microsoft':
      return (
        <svg className={className} viewBox="0 0 24 24" aria-hidden>
          <path fill="#F25022" d="M1 1h10v10H1z" />
          <path fill="#00A4EF" d="M13 1h10v10H13z" />
          <path fill="#7FBA00" d="M1 13h10v10H1z" />
          <path fill="#FFB900" d="M13 13h10v10H13z" />
        </svg>
      );
    case 'gitlab':
      return (
        <svg className={className} viewBox="0 0 24 24" aria-hidden>
          <path
            fill="#E24329"
            d="M12 21.544l3.543-10.882H8.457L12 21.544z"
          />
          <path
            fill="#FC6D26"
            d="M12 21.544l-3.543-10.882H1.73L12 21.544zM12 21.544l3.543-10.882h6.727L12 21.544z"
          />
          <path
            fill="#FCA326"
            d="M1.73 10.662L.42 14.67a.87.87 0 00.316 1.043l11.264 5.831L1.73 10.662zM22.27 10.662l1.31 4.008a.87.87 0 01-.316 1.043L12 21.544l10.27-10.882z"
          />
          <path
            fill="#E24329"
            d="M22.27 10.662h-6.727L18.394 2.9a.435.435 0 01.826 0l3.05 7.762zM1.73 10.662h6.727L5.606 2.9a.435.435 0 00-.826 0L1.73 10.662z"
          />
        </svg>
      );
    case 'linkedin':
      return (
        <svg className={className} viewBox="0 0 24 24" aria-hidden fill="#0A66C2">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
        </svg>
      );
    case 'yahoo':
      // Purple "Y" wordmark — avoid ambiguous X-like cross
      return (
        <svg className={className} viewBox="0 0 24 24" aria-hidden>
          <path
            fill="#6001D2"
            d="M4.2 3h4.3l3.5 6.4L15.5 3H20l-6.1 10.1V21h-3.8v-7.9L4.2 3z"
          />
        </svg>
      );
    default:
      return (
        <span
          className={`${className} rounded-full bg-slate-400 inline-block`}
          aria-hidden
        />
      );
  }
}

/** Stable SSO error codes → human copy for toast / callback (all providers). */
export function humanizeSsoError(codeOrMessage) {
  const raw = String(codeOrMessage || '').trim();
  const lower = raw.toLowerCase();
  const compact = lower.replace(/\s+/g, ' ');
  const key = lower
    .replace(/[+]/g, ' ')
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, '')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '');
  const map = {
    account_not_found:
      'No Candor account for this sign-in yet. Sign up with this provider, or create an account with email and password first.',
    registration_required:
      'No Candor account for this sign-in yet. Sign up with this provider, or create an account with email and password first.',
    provision_failed:
      'We could not create your Candor account from this sign-in. Try again, use email and password, or contact support.',
    subscription_inactive:
      'Your subscription is not active. Open Pricing to start a trial or renew, or contact support.',
    subscription_verify_failed:
      'We could not verify your subscription. Please try again in a moment or contact support.',
    account_inactive: 'This account has been deactivated. Contact support.',
    identity_link_failed: 'Could not link your identity securely. Try again or contact support.',
    domain_not_allowed: 'Your email domain is not allowed for this organization.',
    email_not_verified: 'Verify your email with the identity provider, then try again.',
    access_denied: 'Sign-in was cancelled or denied. You can try another provider.',
    yahoo_idp_misconfigured:
      'Yahoo sign-in is not configured correctly. Ask your admin to register the Agent callback URL in Yahoo Developer Network, or use another provider.',
    yahoo_scope_misconfigured:
      'Yahoo rejected sign-in permissions. Ask your admin to enable OpenID Connect Email and Profile on the Yahoo app, or use another provider.',
    authentication_failed: 'Authentication failed. Please try again or use email and password.',
    already_completed:
      'This sign-in step was already finished. Start sign-in again if you are not logged in.',
    invalid_session: 'Your sign-in session expired. Please start sign-in again.',
    invalid_request: 'Sign-in request was incomplete. Please start sign-in again.',
    provider_unavailable: 'That identity provider is temporarily unavailable. Try another or later.',
    provider_misconfigured:
      'This sign-in method is not fully configured yet. Use email and password, or contact support.',
    cookie_blocked:
      'Secure sign-in could not finish on this site. Please try again, or use email and password.',
    account_error: 'Account setup is incomplete. Contact support if this continues.',
    server_error: 'A temporary server error occurred. Please try again.',
    api_unreachable:
      'Cannot reach the sign-in service. Check that you are online and try again.',
  };
  if (map[key]) return map[key];
  if (map[raw.toLowerCase()]) return map[raw.toLowerCase()];
  if (/no candor account|register first|enable auto-provision|account_not_found/.test(compact)) {
    return map.account_not_found;
  }
  if (/subscription/.test(compact) && /not active|inactive/.test(compact)) {
    return map.subscription_inactive;
  }
  if (/subscription/.test(compact) && /unable to verify|verify/.test(compact)) {
    return map.subscription_verify_failed;
  }
  if (/redirect_uri|mismatch|not fully configured|not allowed for client_app/.test(compact)) {
    return 'This sign-in method is not fully configured. Use email and password, or contact support.';
  }
  if (/fetch failed|network|econnrefused|failed to fetch|api_unreachable|406|405|502|503|504/.test(compact)) {
    return map.api_unreachable;
  }
  if (/cancel|denied|user_cancelled|access_denied/.test(compact)) {
    return map.access_denied;
  }
  if (/^[a-z_]+$/.test(raw.toLowerCase()) && map[raw.toLowerCase()]) {
    return map[raw.toLowerCase()];
  }
  if (raw.length < 40 && /^[a-z0-9_]+$/i.test(raw) && !raw.includes(' ')) {
    return map[raw.toLowerCase()] || map.authentication_failed;
  }
  // Security: never echo long / structured server or exception text to the UI
  if (raw.length > 60 || /traceback|exception|stack|sql|password|api[_-]?key|token/i.test(raw)) {
    return map.authentication_failed;
  }
  // Mild, short messages only
  if (raw.length <= 60 && !/[<>{}[\]`]/.test(raw)) {
    return raw;
  }
  return map.authentication_failed;
}
